import React, { useState } from 'react';
import styled from 'styled-components';
import { Form, Input, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { SET_PASS } from 'api';
import request from 'utils/request';
import PropTypes from 'prop-types';

const InputPassword = styled(Input)`
  &&& {
    border-right-width: 0px !important;
    box-shadow: none;
    border-color: #e5e5e5;
    border-radius: 0px;
    padding-bottom: 11px;
    &:hover {
      border-right-width: 0px !important;
      box-shadow: none;
      border-color: #e5e5e5;
    }
    &:focus {
      border-color: #e5e5e5;
      box-shadow: none;
    }
  }
`;

function RecoveryPassword({}) {
  const { t } = useTranslation();
  const [password, setPassword] = useState(null);

  const handleSubmit = async (value) => {
    const responce = await request(`v1${SET_PASS}`, {
      method: 'post',
      data: {
        password: value.password,
        token: window.location.hash.split('/')[2],
      },
    });
    if (!responce) {
      document.location.assign('/#/auth');
    }
  };

  const onChange = (e) => {
    if (e.target.value.length < 5 && e.target.value.length > 0) {
      setPassword('low');
    } else if (e.target.value.length > 6 && e.target.value.length < 10) {
      setPassword('middle');
    } else if (e.target.value.length > 10) {
      setPassword('strong');
    } else if (e.target.value.length === 0) {
      setPassword(null);
    }
  };

  return (
    <div>
      <div className="w-422 flex items-center justify-center flex-col">
        <h1 className="text-36 font-bold">{t('recovery')}</h1>
        <div className="p-0 w-285 text-center m-center mb-20 text-14">
          {t('inventNewPassword')}
        </div>

        <div className="bg-white w-full text-center p-30  rounded-lg border border-lightGray">
          <Form onFinish={handleSubmit}>
            <Form.Item
              name={['password']}
              rules={[{ required: true, message: t('enterPassword') }]}
            >
              <InputPassword
                className="border-t-0 border-r-0 border-l-0  border-lightGray"
                placeholder={t('enterPassword')}
                onChange={onChange}
              />
            </Form.Item>
            <Form.Item>
              <Button htmlType="submit" className="w-full" type="primary">
                {t('savePassAndLogIn')}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
      {password === 'low' ? (
        <div className="mt-20 flex items-center justify-center w-full">
          <div className="w-64 h-2 rounded-md bg-red mr-7"></div>
          <div className="w-64 h-2 rounded-md bg-darkGray mr-7"></div>
          <div className="w-64 h-2 rounded-md bg-darkGray mr-7"></div>
          <div className="text-red">{t('unreliable')}</div>
        </div>
      ) : password === 'middle' ? (
        <div className="mt-20 flex items-center justify-center w-full">
          <div className="w-64 h-2 rounded-md bg-yellow mr-7"></div>
          <div className="w-64 h-2 rounded-md bg-yellow mr-7"></div>
          <div className="w-64 h-2 rounded-md bg-darkGray mr-7"></div>
          <div className="text-yellowPass">{t('middle')}</div>
        </div>
      ) : password === 'strong' ? (
        <div className="mt-20 flex items-center justify-center w-full">
          <div className="w-64 h-2 rounded-md bg-green mr-7"></div>
          <div className="w-64 h-2 rounded-md bg-green mr-7"></div>
          <div className="w-64 h-2 rounded-md bg-green mr-7"></div>
          <div className="text-greenPass">{t('strong')}</div>
        </div>
      ) : null}
    </div>
  );
}

RecoveryPassword.propTypes = {};

export default RecoveryPassword;
